import { HttpContext } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ALLOW_ANONYMOUS,
  DA_SERVICE_TOKEN,
  ITokenService,
  SocialService
} from '@delon/auth';
import { _HttpClient } from '@delon/theme';
import { FcwidgetService } from 'src/app/core/util/fcwidget.service';
import CountriesJson from 'src/assets/data/countries.json';

@Component({
  selector: 'layout-passport',
  templateUrl: './passport.component.html',
  styleUrls: [
    './passport-light.component.less',
    './passport-dark.component.less'
  ],
  providers: [SocialService],
  standalone: false
})
export class LayoutPassportComponent implements OnInit {
  links = [];
  countryOptions: any[] = [];
  fblink: any;
  iglink: any;
  qnelink: any;
  countryCode = 'MY';
  darkModeSwitch = false;
  fragment: string = '';
  logoYW = '';
  logoYB = '';
  lightUrl = './assets/img/passport/N3 Now Live Light Element - 1.png';
  darkUrl = './assets/img/passport/N3 Now Live Dark Element - 1.png';


  lightUrlMobile = './assets/img/passport/N3 Now Live Light Element - M.png';
  darkUrlMobile = './assets/img/passport/N3 Now Live Dark Element - M.png';

  btnDarkUrl = './assets/img/passport/N3 Now Live Dark Element - 2.png';
  btnLightUrl = './assets/img/passport/N3 Now Live Light Element - 2.png';
  loginBackgroundUrl = this.lightUrl;
  loginBannerMobile = this.lightUrlMobile;
  buttonImgUrl = this.btnLightUrl;


  backMobile = './assets/img/back-mobile.mp4' ;
  backMobileDark = './assets/img/back-mobile-dark.mp4';
  loginBackgroundUrlMobile = this.backMobile;

  readonly qiLoginBackgroundUrl =
    'https://cdn.qne.cloud/qca/assets/img/login-background.webp';

  /** True only on eintegrator.qne.cloud (or localhost:7002 for dev). */
  get isQi() {
    const { hostname, port } = window.location;
    return (
      hostname === 'eintegrator.qne.cloud' ||
      (hostname === 'localhost' && port === '7002')
    );
  }

  constructor(
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
    private fcWidget: FcwidgetService,
    private http: _HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    if (this.isQi) {
      this.logoYW =
        'https://cdn.qne.cloud/qca/assets/img/qi/logo-transparent-yellow-white.png';
      this.logoYB =
        'https://cdn.qne.cloud/qca/assets/img/qi/logo-transparent-yellow-blue.png';
    } else {
      this.logoYW =
        'https://cdn.qne.cloud/qca/assets/img/qca/logo-transparent-yellow-white.webp';
      this.logoYB =
        'https://cdn.qne.cloud/qca/assets/img/qca/logo-transparent-yellow-blue-512w.webp';
    }
  }

  goToLink() {
    window.open('https://n3.qne.cloud/#/passport/login', '_blank');
  }

  ngOnInit(): void {
    if (this.isQi) {
      document.title = 'QNE E-Invoice Integrator';
    }
    this.tokenService.clear();
    this.countryOptions = [...CountriesJson];
    if (this.isQi) {
      this.darkModeSwitch = false;
      this.fragment = '';
    } else {
      this.darkModeSwitchClicked();
    }
    this.loadCountry();
  }

  get companyName() {
    // if (this.countryCode === 'MY') {
    //   return 'QNE OPTIMUM SDN. BHD.'
    // }
    // return 'QNE SOFTWARE SDN. BHD.';
    return 'QNE SOFTWARE MALAYSIA SDN. BHD.';
  }

  get currentYear() {
    return new Date().getFullYear();
  }

  get copyrightYear() {
    return `2022-${this.currentYear}`;
  }

  loadCountry() {
    this.http
      .get(
        'https://ipinfo.io/json',
        {},
        { context: new HttpContext().set(ALLOW_ANONYMOUS, true) }
      )
      .subscribe({
        next: (res: any) => {
          this.countryCode = res?.country;
          var country = this.countryOptions.find(
            o => o.code == this.countryCode
          );
          if (!country) this.countryCode = 'MY';

          this.changeCountry();
          this.fcWidget.preloadWhenReady();
        },
        error: () => {
          this.countryCode = 'PH';
          this.changeCountry();
          this.fcWidget.preloadWhenReady();
        }
      });
  }

  websiteLink() {
    if (this.countryCode === 'MY') {
      return 'https://qne.cloud/my/';
    } else {
      return 'https://www.qne.cloud/ph/';
    }
  }

  changeCountry() {
    this.fcWidget.changeCountry(this.countryCode);

    switch (this.countryCode) {
      case 'PH':
        this.fblink = 'https://www.facebook.com/QNESoftwarePH/';
        this.iglink = 'https://www.instagram.com/qnesoftwareph/';
        this.qnelink = 'https://qne.com.ph/';
        break;
      case 'MM':
        this.fblink = 'https://www.facebook.com/QNESoftwareMyanmar';
        this.iglink = 'https://www.instagram.com/qnesoftwaremy/';
        this.qnelink = 'https://www.qne.com.my/';
        break;
      default:
        this.fblink = 'https://www.facebook.com/qne.software';
        this.iglink = 'https://www.instagram.com/qnesoftwaremy/';
        this.qnelink = 'https://www.qne.com.my/';
        break;
    }
  }

  get widgetReady$() {
    return this.fcWidget.widgetReady$;
  }

  openChat() {
    this.fcWidget.open();
  }

  darkModeSwitchClicked() {
    if (this.isQi) {
      return;
    }

    let url = this.router.url.replace('#darkmode', '');

    if (this.darkModeSwitch) {
      this.router.navigateByUrl(
        url + (url.endsWith('#') ? 'darkmode' : '#darkmode')
      );
      this.fragment = 'darkmode';
      this.darkModeSwitch = true;
      if (!this.isQi) {
        this.loginBackgroundUrl = this.darkUrl;
        this.buttonImgUrl = this.btnDarkUrl;
        this.loginBannerMobile = this.darkUrlMobile;
        // this.loginBackgroundUrlMobile = this.backMobileDark;
      }
    } else {
      if (!this.isQi) {
        this.loginBackgroundUrl = this.lightUrl;
      }
      this.router.navigateByUrl(url);
      this.darkModeSwitch = false;
      if (!this.isQi) {
        this.buttonImgUrl = this.btnLightUrl;
        this.loginBannerMobile = this.lightUrlMobile;
      }
      this.fragment = '';
      // this.loginBackgroundUrlMobile = this.backMobile;
    }
  }
}
